/* START GENAI@GHCOPILOT */
import { HandlerEvent } from 'post-robot';
/* END GENAI@GHCOPILOT */
/* START GENAI@GHCOPILOT */
import { error, ValidationError } from 'common/errors';
import { pushErrors, pushCofEnrollRequest, pushCofEnrollResponse } from 'common/gamp';
/* START GENAI@GHCOPILOT */
import { getAccessToken, getApiKey, getIsFeatureToggleEnabled } from 'communicator/store/selectors';
/* END GENAI@GHCOPILOT */
import { CoFEnrollResponse, FetchCoFEnrollOptions } from '../../../types/api/cof-enroll';
import fetchEnrollCardCoF from '../../utils/api/cof-enroll';
import getGenericError from '../../utils/generic-error';
import { markEnd, markStart } from '../../utils/instrumentation';
/* END GENAI@GHCOPILOT */

export default async function cofEnroll(
  event: HandlerEvent<FetchCoFEnrollOptions>
): Promise<CoFEnrollResponse | ValidationError> {
  try {
    const stime = Date.now();
    markStart('COF_ENROLL');
    const { data } = event;
    /* START GENAI@GHCOPILOT */
    const isCofEnrollmentEnabled = getIsFeatureToggleEnabled('enableCofEnrollment');
    /* END GENAI@GHCOPILOT */

    // Validate input parameters
    /* START GENAI@GHCOPILOT */
    if (!data.srcCorrelationId || !data.serviceId) {
      /* END GENAI@GHCOPILOT */
      /* START GENAI@GHCOPILOT */
      markEnd('COF_ENROLL', {
        doFlush: true,
        failure: true,
        reason: 'Missing required parameters'
      });
      /* END GENAI@GHCOPILOT */

      pushErrors('COF_ENROLL', 'Missing required parameters');
      return error('ERROR', 'Invalid parameter');
    }

    pushCofEnrollRequest();
    /*eslint-disable-next-line*/
    console.log(`isCofEnrollmentEnabled ?: ${isCofEnrollmentEnabled}`);
    /* START GENAI@GHCOPILOT */
    if (!isCofEnrollmentEnabled) {
      markEnd('COF_ENROLL', { doFlush: true, failure: true, reason: 'Feature not enabled' });
      pushErrors('COF_ENROLL', 'Feature not enabled');
      return error('ERROR', 'This API is not enabled');
    }
    /* END GENAI@GHCOPILOT */
    /* START GENAI@GHCOPILOT */
    /* START GENAI@GHCOPILOT */

    const accessToken = getAccessToken()?.token ?? '';
    /* END GENAI@GHCOPILOT */
    const enrollResponse = await fetchEnrollCardCoF({
      /* START GENAI@GHCOPILOT */
      accessToken,
      /* END GENAI@GHCOPILOT */
      apikey: getApiKey(),
      enrollmentReferenceData: data.enrollmentReferenceData,
      idToken: '', // idToken is not used in this context, but kept for compatibility
      serviceId: data.serviceId,
      srcClientId: data.srcClientId,
      srcCorrelationId: data.srcCorrelationId,
      srciTransactionId: data.srciTransactionId,
      /* START GENAI@GHCOPILOT */
      srcTokenRequestData: data.srcTokenRequestData
      /* END GENAI@GHCOPILOT */
    });
    /* END GENAI@GHCOPILOT */

    if (!enrollResponse.ok) {
      const err = getGenericError(enrollResponse);
      markEnd('COF_ENROLL', { doFlush: true, failure: true, reason: err });
      pushErrors('COF_ENROLL', err);
      return error('UNKNOWN_ERROR', err);
    }

    pushCofEnrollResponse('SUCCESS', Date.now() - stime);

    markEnd('COF_ENROLL');

    /* START GENAI@GHCOPILOT */
    const cofEnrollResponse: CoFEnrollResponse = {
      maskedCard: enrollResponse.data.maskedCard,
      srcCorrelationId: enrollResponse.data.srcCorrelationId
    };

    return cofEnrollResponse;
    /* END GENAI@GHCOPILOT */
  } catch (err: unknown) {
    const sErr = err instanceof Error ? err.message : 'Unknown error';
    markEnd('COF_ENROLL', { doFlush: true, failure: true, reason: sErr });
    pushErrors('COF_ENROLL', sErr);
    return error('UNKNOWN_ERROR', sErr);
  }
}

/* END GENAI@GHCOPILOT */
